import React, { PureComponent } from "react";
import { BarChart, Bar, Tooltip, ResponsiveContainer, XAxis } from "recharts";
import Loader from "./../Loader/Loader.js";
import { Metric, selectFormat, MAIN_COLORS } from "components/Utils/Utils.js";
import Heading from "./../Elements/Heading";

class SocialKeyStats extends PureComponent {
  componentDidMount() {
    this.props.childRef(this);
  }

  formatMetricKey = (key) => {
    return key
      .split("_")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      const total = payload.reduce((acc, cur) => acc + (cur.value || 0), 0);

      return (
        <div className="standard-tooltip">
          {label && (
            <header className="standard-tooltip__header">
              <span className="standard-tooltip__key-header">Date:</span>
              <span className="standard-tooltip__value-header">{label}</span>
            </header>
          )}
          <main className="standard-tooltip__main">
            {payload.map((entry, index) => (
              <div className="standard-tooltip__item" key={`item-${index}`}>
                <span
                  className="standard-tooltip__icon"
                  style={{ background: entry.color }}
                ></span>
                <span
                  className="standard-tooltip__key"
                  style={{ color: entry.color }}
                >
                  {entry.name}
                </span>
                <span className="standard-tooltip__value">
                  {selectFormat("number", entry.value, null)}
                </span>
              </div>
            ))}
            <div className="standard-tooltip__dilimiter1"></div>
            <div className="standard-tooltip__item">
              <span className="standard-tooltip__key total">Total</span>
              <span className="standard-tooltip__value">
                {selectFormat("number", total, null)}
              </span>
            </div>
          </main>
        </div>
      );
    }

    return null;
  };

  KeyStatsItem = ({ title, data, metricsByDay }) => {
    const metricKey = title.toLowerCase().replace(" ", "_");
    const formattedMetricKey = this.formatMetricKey(metricKey);

    const platforms =
      metricsByDay[metricKey].length > 0
        ? Object.keys(metricsByDay[metricKey][0])
        : [];
    platforms.splice(platforms.indexOf("date"), 1);

    return (
      <div className="col-lg-3 col-sm-6 col-12 key-stats--item mb-4">
        <div className="row row--header">
          <div className="col-12">
            <Heading size={5}>{formattedMetricKey}</Heading>
            <Metric {...data.metrics[metricKey]} size={"md"} />
          </div>
        </div>
        <ResponsiveContainer height={150} width="100%" className="mt-5">
          <BarChart data={metricsByDay[metricKey]}>
            <Tooltip
              cursor={{ fill: "#eee", opacity: 0.5 }}
              content={<this.CustomTooltip />}
            />
            <XAxis dataKey="date" hide />
            {platforms.map((platform, index) => (
              <Bar
                key={platform}
                dataKey={platform}
                stackId="a"
                fill={MAIN_COLORS[index % MAIN_COLORS.length]}
                cursor="pointer"
              />
            ))}
          </BarChart>
        </ResponsiveContainer>
      </div>
    );
  };

  generateDataForExport = () => {
    const data = this.props.data.metrics;
    let formattedData = [];

    Object.keys(data).map((i) =>
      formattedData.push({
        Metric: i
          .replace("_", " ")
          .split(/ /g)
          .map(
            (word) =>
              `${word.substring(0, 1).toUpperCase()}${word.substring(1)}`
          )
          .join(" "),
        Value: selectFormat("number", data[i].value, "0,0"),
      })
    );

    return formattedData;
  };

  getExportData = () => ({
    data: this.generateDataForExport(),
    opts: {
      type: "other",
    },
  });

  render() {
    const { data, loading } = this.props;

    if (loading) {
      return <Loader minHeight={340} col={"col-12 col-md-6"} />;
    }

    const metricsOrder = [
      "published_posts",
      "impressions",
      "views",
      "engagements",
    ];
    const orderedMetrics = metricsOrder.filter(
      (metric) => data.metrics[metric]
    );

    return (
      <div className="row key-stats border-between-metrics">
        {orderedMetrics.map((key) => (
          <this.KeyStatsItem
            key={key}
            title={key}
            data={data}
            metricsByDay={data.metricsByDay}
          />
        ))}
      </div>
    );
  }
}

export default SocialKeyStats;
